// Default hotkey → command bindings. Combos are normalized as
// lowercase modifier-prefixed strings: "ctrl+shift+f", "alt+1", "f13".
// Modifier order: ctrl, alt, shift, meta. Keys use KeyboardEvent.key
// (letters lowercased), except digits which are matched via event.code so
// macOS Option+digit still works.
//
// User-configurable bindings can later replace this constant; the shape is
// the single source of truth for command hotkeys.
export const DEFAULT_COMMAND_HOTKEYS = {
  f16: 'enterLong',
  f17: 'enterShort',
  'ctrl+shift+f': 'flatten',
};
